<template>
  <div v-if="business_type" class="text-center report-wrapper">
    <h3 class="title">Analyzing your traffic</h3>
    <img class="radar-img" src="@/assets/images/report/half_radar.svg" alt="scening radar" loading="eager">

    <div class="card">
      <img src="@/assets/images/report/stars.svg" alt="stars" class="stars" loading="eager">

      <p class="quotes" v-html="business.text.main" />

      <picture>
        <source media="(max-width: 1199px)" :srcset="imagePath(business.avatar.sm)">
        <img :src="imagePath(business.avatar.lg)" class="avatar" alt="avatar image" loading="eager">
      </picture>

      <p class="who-is" v-html="business.text.avatar" />

      <img :src="imagePath(business.logo)" alt="" class="logo" :style="{ height: agency ? '16px' : '39px' }" loading="eager">
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { imagePath } from "@/utils";

export default {
  name: "1",
  data: () => ({
    agency: {
      text: {
        main: `“We saved our clients <strong>over $21,000</strong> in just one month!<br> only by blocking click fraud using ClickCease”`,
        avatar: `Jeff Wauthier<br>Marketing Manager, Wit Digital`,
      },
      avatar: {
        sm: "report/agency_avatar.png",
        lg: "report/agency_avatar@2x.png",
      },
      logo: "report/witdigital_logo.svg",
    },
    regular: {
      text: {
        main: '“ClickCease put my mind at ease, with excellent protection and top-notch support. They bring real value to our campaigns”',
        avatar: `Nophry Lev-Ari,<br>Senior Marketing Specialist`,
      },
      avatar: {
        sm: "report/regular_avatar.png",
        lg: "report/regular_avatar@2x.png",
      },
      logo: "report/walkme_logo.png",
    }

  }),
  setup() {
    return { imagePath }
  },
  computed: {
    ...mapState({ get_agency: 'agency'}),

    business_type() {
      return this.get_agency ? 'agency' : 'regular';
    },

    business() {
      return this[this.business_type] || this.regular;
    }
  }
}
</script>

<style lang="scss">
@import "src/assets/style/colors";

.report-wrapper {
  position: relative;

  .radar-img {
    max-width: -webkit-fill-available;
  }

  .card {
    width: 576px;
    max-width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding: 32px 40px 28px;

    img.stars {
      margin-bottom: 12px;
    }

    .quotes {
      font-family: "Sofia Pro Light";
      font-size: 20px;
      margin-bottom: 12px;
      color: $black;

      strong {
        color: $orange;
      }
    }

    img.avatar {
      height: 76px;
    }

    .who-is {
      font-family: "Sofia Pro Light";
      font-size: 16px;
      color: $black;
    }
  }
}
</style>